// Arquivos que o relatorio recebe do servidor como Blob (planilha .xlsx e CSVs com BOM). Texto passaria pela
// decodificacao do navegador, que descarta o BOM, e o Excel voltaria a abrir os acentos errados.
export const downloadBlob = (fileName, blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  setTimeout(() => URL.revokeObjectURL(url));
};

// Nome gerado pelo servidor (fuso da conta), lido do Content-Disposition.
export const fileNameFromDisposition = disposition =>
  /filename="([^"]+)"/.exec(disposition || '')?.[1] || null;

// Corpo JSON (aviso de envio por e-mail, erro) de uma requisicao feita com responseType 'blob'.
export const readJsonBlob = async blob => {
  try {
    return JSON.parse(await blob.text());
  } catch {
    return null;
  }
};
